var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('sd-button',{attrs:{"id":"btn-valuation","size":100,"has-full-width":"","disabled":!_vm.getEstimationIsReady},on:{"click":function($event){_vm.setCurrentView(_vm.ValuationRequest);
      _vm.trackLink('vor ort bewertung anfragen');}}},[_vm._v(" Vor-Ort-Bewertung anfragen ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }